import { createAsyncThunk } from '@reduxjs/toolkit';
import EmployersApi from 'api/EmployersApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetEmployerData = (api: EmployersApi) =>
  createAsyncThunk('employers/getLogo', async (data: { payrollProvider: string; employerId: string }, thunkApi) => {
    try {
      const { payrollProvider, employerId } = data;
      return await api.getEmployerData(payrollProvider, employerId);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      throw error;
    }
  });
